import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router';
import { UserContext } from '../../App';

const PrivateRoute = ({children , ...rest}) => {
    //const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const { value, value2 } = React.useContext(UserContext);
    const [loggedInUser, setLoggedInUser] = value;
    const [buyProduct, setbuyProduct] = value2;
    return (
        <div>
            <Route
        {...rest}
        render={({ location }) =>
          loggedInUser.email ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
        </div>
    );
};

export default PrivateRoute;